import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_BottomToolbar,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Link, useNavigate} from "react-router-dom";
import ArrivalMaterialService from "../../../../../API/orders/warehouse/material/ArrivalMaterialService";
import ModalUpdateOrAddMaterialArrival from "../material/arrival/ModalUpdateOrAddMaterialArrival";
import CurrencyService from "../../../../../API/common/CurrencyService";
import SupplierService from "../../../../../API/orders/warehouse/supplier/SupplierService";
import WarehouseService from "../../../../../API/orders/warehouse/WarehouseService";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import {materialReserveState} from "../../../../../data/MaterialReserveState";
import ModalSetSupplier from "./ModalSetSupplier";
import MaterialReserveService from "../../../../../API/orders/reservation/MaterialReserveService";
import ButtonCreate from "../../../button/ButtonCreate";
import {ModalSelectAction} from "../../../modal/ModalSelectAction";
import MenuItem from "@mui/material/MenuItem";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import {calcFilterData} from "../../../../../utils/common/calcFilterData";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Menu,
    Paper,
    Stack,
    Tooltip,
    Typography
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import MaterialWarehouseTableRMEU from "../material/materialwarehouse/MaterialWarehouseTableRMEU";
import MaterialWarehouseService from "../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import ButtonSelectAction from "../../../button/ButtonSelectAction";
import DateRangeFilter from "../../../filter/DateRangeFilter";
import {HeaderOPTAdditionally} from "../../orders/organization/production/HeaderOPT";
import NameModal from "../../../modal/NameModal";

const rowActionMenuItemSx = {
    margin: "0 8px",
    borderRadius: "4px",
    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
};

const SetStatusMenuItem = ({row, closeMenu, onSetState}) => {
    const [subMenuAnchor, setSubMenuAnchor] = useState(null);

    return (
        <>
            <MenuItem
                onClick={(event) => {
                    event.stopPropagation();
                    setSubMenuAnchor(event.currentTarget);
                }}
                sx={{
                    ...rowActionMenuItemSx,
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '8px',
                }}
            >
                Установить статус
                <ChevronRightIcon sx={{fontSize: 20}}/>
            </MenuItem>
            <Menu
                anchorEl={subMenuAnchor}
                open={Boolean(subMenuAnchor)}
                onClose={() => setSubMenuAnchor(null)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                MenuListProps={{
                    sx: {minWidth: 'unset'},
                }}
            >
                {Object.entries(materialReserveState).map(([state, label]) => (
                    <MenuItem
                        key={state}
                        onClick={() => {
                            onSetState(row.original, state);
                            setSubMenuAnchor(null);
                            closeMenu();
                        }}
                        sx={rowActionMenuItemSx}
                    >
                        {label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

const ReservationMaterialTable = ({
                                      data,
                                      setData,
                                      isColumnOrder,
                                      isColumnMaterialWarehouse,
                                      isColumnOptimization,
                                      enableGrouping,
                                      expanded,
                                      pageSize,
                                      change,
                                      setChange,
                                      columnGrouping,
                                      titleModalUpdateOrAddMaterialArrival,
                                      typeMaterial,
                                      tableOptions,
                                      tableOptionsHandle,
                                      handleModalAlert,
                                      globalFilter,
                                      handleSearchQuery,
                                      filteredData,
                                      columnsFilter,
                                      warningIds,
                                      statusList,
                                      calcWarningString
                                  }) => {
        const [rowSelection, setRowSelection] = useState([]);
        const [openSelectRowModal, setOpenSelectRowModal] = useState(false);
        const [createOrUpdateModalOpen, setCreateOrUpdateModalOpen] = useState(false);
        const [createOrUpdateIndividualModalOpen, setCreateOrUpdateIndividualModalOpen] = useState(false);
        const [setSupplierModalOpen, setSetSupplierModalOpen] = useState(false);
        const [date, setDate] = useState({});
        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [materialDeliveryDate, setMaterialDeliveryDate] = useState(null);
        const [currencyList, setCurrencyList] = useState([]);
        const [currencyMap, setCurrencyMap] = useState(new Map);
        const [currencyId, setCurrencyId] = useState(null);
        const [supplierList, setSupplierList] = useState([]);
        const [supplierId, setSupplierId] = useState(null);
        const [warehouseList, setWarehouseList] = useState([]);
        const [warehouseId, setWarehouseId] = useState(null);
        const [fillReserveModalOpen, setFillReserveModalOpen] = useState(false)
        const [fillReserveMaterial, setFillReserveMaterial] = useState(null)
        const [modalDivide, setModalDivide] = useState(false);
        const [showColumnFilters, setShowColumnFilters] = useState(false)
        const [loading, setLoading] = useState(false)
        const profile = JSON.parse(localStorage.getItem("profile"))
        const isSettingsRole = !!profile?.userRoles?.find(el => el.name === "ROLE_ORGANIZATION_USER_SETTINGS")

        const handleShowColumnFilters = () => {
            setShowColumnFilters(!showColumnFilters)
            if (showColumnFilters) {
                handleSearchQuery([], data, null, true)
            }
        }

        useEffect(() => {
            CurrencyService.getAll().then(function (response) {
                let data = response.data;
                data.sort((a, b) =>
                    a.defaultBase === b.defaultBase ? 0 : a.defaultBase ? -1 : 1
                );
                setCurrencyList(data);
                data.forEach((c) => {
                    currencyMap.set(c.id, c);
                });
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
            SupplierService.get().then(function (response) {
                let data = response.data;
                setSupplierList(data);
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
            WarehouseService.getAll().then(function (response) {
                let data = response.data;
                setWarehouseList(data);
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, []);


        const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
        const currentSelection = normalizeSelection(rowSelection)

        const handleOpenSelectRowModal = () => {
            const rowSelectionData = data.filter(el => rowSelection.includes(el.id))
            const oneMaterial = rowSelectionData.every(el => el?.materialId === rowSelectionData[0]?.materialId)

            setFillReserveMaterial(oneMaterial ? rowSelectionData[0]?.materialId : null)
            setOpenSelectRowModal(true)
        }

        const handleUpdateReserve = useCallback(
            (row) => {
                setCurrentEditRowData(row);
                setSetSupplierModalOpen(true);
                setSupplierId(row.supplierId);
            },
            [data, currentEditRowData, setCurrentEditRowData],
        );
        const handleReturnPurchase = (row) => {
            MaterialReserveService.returnPurchase(row.id).then(function (response) {
                const newData = data.filter(el => el.id !== row.id)
                setData(newData)
                calcWarningString(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
        const handleDelete = (row) => {
            MaterialReserveService.delete(row.id).then(function (response) {
                const newData = data.filter(el => el.id !== row.id)
                setData(newData)
                calcWarningString(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Данные удалены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
        const handleDeleteArrival = (row) => {
            const ids = row ? [row.id] : rowSelection
            MaterialReserveService.deleteArrival(ids).then(function (response) {
                if (row) {
                    const newData = data.map(el => el.id === row.id ? {...el, arrivalName: null, arrivalDate: null} : el)
                    setData(newData)
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                } else {
                    const newData = data.map(el => rowSelection.includes(el.id) ? {
                        ...el,
                        arrivalName: null,
                        arrivalDate: null
                    } : el)
                    setData(newData)
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                    setOpenSelectRowModal(false)
                    setRowSelection([])
                }
                handleModalAlert("Удалено из прихода", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const handleFillReserve = (row) => {
            row && setCurrentEditRowData(row)
            setFillReserveModalOpen(true);
        }


        const handleCloseUpdateReserve = () => {
            setSetSupplierModalOpen(false);
            setSupplierId(null);
        };
        const handleCloseWarehouse = () => {
            setCurrentEditRowData(null)
            setFillReserveModalOpen(false)
        }

        const handleCloseCreateOrUpdateModalOpen = () => {
            setCreateOrUpdateModalOpen(false)
            setCurrencyId(null);
            setSupplierId(null);
            setWarehouseId(null);
        };

        const handleCloseCreateOrUpdateIndividualModalOpen = () => {
            setCreateOrUpdateIndividualModalOpen(false)
            setCurrencyId(null);
            setSupplierId(null);
            setWarehouseId(null);
        };

        const handleSetSupplier = async (supplierId, onClose) => {
            MaterialReserveService.setSupplier(currentEditRowData.id, supplierId, typeMaterial)
                .then(function (response) {
                    const newData = data.map(el => el.id === response.data.id ? {
                        ...el,
                        supplierName: response.data.supplierMaterial.supplier.name,
                        supplierMaterialId: response.data.supplierMaterial.id,
                        supplierId: response.data.supplierMaterial.supplier.id
                    } : el)
                    setData(newData)
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                    onClose()
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        };
        const handleSubmitWarehouse = (warehouseId) => {
            setLoading(true)
            if (currentEditRowData?.id) {
                MaterialReserveService.fillFromWarehouse(currentEditRowData.id, warehouseId)
                    .then(function (response) {
                        setFillReserveMaterial(null)
                        setFillReserveModalOpen(false)
                        const newData = data.filter(el => el.id !== currentEditRowData.id)
                        setData(newData)
                        calcWarningString(newData)
                        handleSearchQuery(globalFilter, newData)
                        setCurrentEditRowData(null)
                        handleModalAlert("Резервы заполнены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
            } else {
                MaterialReserveService.fillFromWarehouseByIds(rowSelection, warehouseId).then(function () {
                    setOpenSelectRowModal(false)
                    setRowSelection([])
                    setFillReserveMaterial(null)
                    setFillReserveModalOpen(false)
                    const newData = data.filter(el => !rowSelection.includes(el.id))
                    setData(newData)
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Резервы заполнены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
            }
        }
        const handleGetArrivalAndFollow = (row) => {
            ArrivalMaterialService.get(row.arrivalId).then(function (response) {
                navigate('/organization/materials-price-unit-arrival/' + row.arrivalId + '/' + encodeURIComponent(row.arrivalName) + '/' + response.data?.currencyArrival?.curAbbreviation + '/'
                    + response.data?.supplier?.id + '/' + response.data?.warehouse?.id);
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: 'materialArticleNumber',
                    header: 'Артикул',
                    accessorKey: 'materialArticleNumber',
                    minSize: 100,
                },
                {
                    id: 'materialName',
                    header: 'Наименование',
                    accessorKey: 'materialName',
                    size: 800,
                    Cell: ({row, cell}) => {
                        return <Tooltip arrow placement="bottom"
                                        title={row.original.materialName}><Box
                            sx={{
                                display: "inline-block",
                                width: "800px",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    }

                },
                {
                    id: 'supplierName',
                    header: 'Поставщик',
                    accessorKey: 'supplierName',
                    minSize: 55,
                    maxSize: 55,
                },
                {
                    id: 'materialReserveState',
                    header: 'Статус',
                    accessorKey: 'materialReserveState',
                    minSize: 55,
                    maxSize: 55,
                    Cell: ({cell}) => materialReserveState[cell.getValue()],
                    filterFn: (row, id, filterValue) => {
                        return materialReserveState[row.original.materialReserveState].toLowerCase().includes(filterValue.toLowerCase())
                    },
                    filterVariant: 'multi-select',
                    filterSelectOptions: statusList,
                    muiFilterTextFieldProps: {
                        placeholder: 'Отфильтровать по статус',
                        sx: {
                            width: '140px',
                        },
                    }
                },
                {
                    id: 'plans',
                    header: 'План',
                    accessorKey: 'plans',
                    minSize: 15,
                    maxSize: 15,
                },
                {
                    id: 'arrivalName',
                    header: 'Приход',
                    accessorKey: 'arrivalName',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row, rowIndex}) => {
                        return (
                            <span>
                            <Typography
                                sx={{
                                    color: "#006CCC",
                                    cursor: "pointer",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }}
                                onClick={() => handleGetArrivalAndFollow(row.original)}
                            >
                                {row.original.arrivalName}
                            </Typography>
                            </span>
                        );

                    },
                },
                {
                    id: 'arrivalDate',
                    header: 'Дата прихода',
                    accessorKey: 'arrivalDate',
                    size: 10,
                    Cell: ({cell, row}) => {
                        const value = cell.getValue()
                        if (value) {
                            return new Date(value).toLocaleDateString('en-GB');
                        }
                    },
                    sortingFn: 'datetime',
                    Filter: ({column}) => <DateRangeFilter
                        column={column}
                    />,
                },
                {
                    id: 'quantity',
                    header: 'Необходимо.',
                    accessorKey: 'quantity',
                    aggregationFn: 'sum',
                    maxSize: 65,
                    size: 65,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    AggregatedCell: ({cell, table}) => (
                        <>
                            <Box sx={{
                                color: 'primary.main',
                                fontWeight: 'bold'
                            }}>
                                {cell.getValue()?.toLocaleString?.('en-US', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 3,
                                })}
                            </Box>
                        </>
                    ),
                },
                {
                    id: 'availabilityQuantity',
                    header: 'Заполнение резерва',
                    accessorKey: 'availabilityQuantity',
                    aggregationFn: 'sum',
                    maxSize: 65,
                    size: 65,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    AggregatedCell: ({cell, table}) => (
                        <>
                            <Box sx={{
                                color: 'success.main',
                                fontWeight: 'bold'
                            }}>
                                {cell.getValue()?.toLocaleString?.('en-US', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 3,
                                })}
                            </Box>
                        </>
                    ),
                },
                {
                    id: 'orderedQuantity',
                    header: 'Заказано',
                    accessorKey: 'orderedQuantity',
                    aggregationFn: 'sum',
                    maxSize: 65,
                    size: 65,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    AggregatedCell: ({cell, table}) => (
                        <>
                            <Box sx={{
                                color: 'secondary.main',
                                fontWeight: 'bold'
                            }}>
                                {cell.getValue()?.toLocaleString?.('en-US', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 3,
                                })}
                            </Box>
                        </>
                    ),
                },
                {
                    id: 'needToOrderQuantity',
                    header: 'Необходимо заказать',
                    accessorKey: 'needToOrderQuantity',
                    aggregationFn: 'sum',
                    maxSize: 65,
                    size: 65,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({cell, row}) => cell.getValue()?.toFixed(3),
                    AggregatedCell: ({cell, table}) => (
                        <>
                            <Box sx={{
                                color: 'error.light',
                                fontWeight: 'bold'
                            }}>
                                {cell.getValue()?.toLocaleString?.('en-US', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 3,
                                })}
                            </Box>
                        </>
                    ),
                },
                {
                    id: 'quantityInStock',
                    header: 'Свободно на складе',
                    accessorKey: 'quantityInStock',
                    aggregationFn: 'sum',
                    maxSize: 65,
                    size: 65,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({cell, row}) => cell.getValue()?.toFixed(3),
                    AggregatedCell: ({cell, table}) => (
                        <>
                            <Box sx={{
                                color: 'success.main',
                                fontWeight: 'bold'
                            }}>
                                {cell?.row.original?.quantityInStock}
                            </Box>
                        </>
                    )
                },
                {
                    id: 'orderNumbers',
                    header: 'Заказы',
                    accessorKey: 'orderNumbers',
                    minSize: 15,
                    maxSize: 15,
                    /*    filterVariant: 'multi-select',
                        filterSelectOptions: orderList,
                        filterFn: (row, id, filterValue) => {
                            return OrderUtil.checkNumberOrder(row.getValue(id), filterValue)
                        },*/
                },
                {
                    header: 'id',
                    id: 'id',
                    accessorKey: 'id',
                    enableHiding: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                },
            ];

            if (isColumnMaterialWarehouse) {
                baseColumns.splice(2, 0, {
                    id: 'size',
                    header: 'Размеры',
                    accessorKey: 'size',
                    minSize: 15,
                    maxSize: 15,
                });
            }
            if (isColumnOptimization) {
                baseColumns.splice(2, 0, {
                    id: 'optimizationName',
                    header: 'Оптимизация',
                    accessorKey: 'optimizationName',
                    minSize: 150,
                    maxSize: 150,
                    Cell: ({cell, row}) => {
                        const optimizationId = row.original.optimizationId;
                        const optimizationName = cell.getValue();

                        if (optimizationId) {
                            return (
                                <li key={optimizationName}>
                                    <Link
                                        to={'/organization/requests-cutting/optimization/' + optimizationId + '/' + encodeURIComponent(optimizationName)}>
                                        {optimizationName}
                                    </Link>
                                </li>
                            );
                        } else {
                            return null;
                        }
                    },
                });
            }

            return baseColumns;

        }, [data, setData, isColumnOrder, filteredData]);

        const handleCreateData = () => {
            const ArrivalMaterial = {
                arrivalState: 'EXECUTION_OF_APPLICATION',
                comment: '',
                currencyArrival: null,
                date: null,
                id: null,
                materialDeliveryDate: null,
                supplier: null,
                warehouse: null,
            };
            setCurrentEditRowData(ArrivalMaterial);
            setDate(new Date());
            setMaterialDeliveryDate(new Date())
            setCreateOrUpdateModalOpen(true);
        };

        const handleCreateIndividualData = () => {
            const ArrivalMaterial = {
                arrivalState: 'EXECUTION_OF_APPLICATION',
                comment: '',
                currencyArrival: null,
                date: null,
                id: null,
                materialDeliveryDate: null,
                supplier: null,
                warehouse: null,
            };
            setCurrentEditRowData(ArrivalMaterial);
            setDate(new Date());
            setMaterialDeliveryDate(new Date())
            setCreateOrUpdateIndividualModalOpen(true);
        };

        const handleSubmitCreateByReserves = () => {
            currentEditRowData.date = date === null ? null : DateTimeUtil.dateConvert(date);
            currentEditRowData.materialDeliveryDate = materialDeliveryDate === null ? null : DateTimeUtil.dateConvert(materialDeliveryDate);

            const currentCurrencyId = currencyId === null ? currencyList[0].id : currencyId;
            const currentWarehouseId = warehouseId == null ? warehouseList[0].id : warehouseId;

            ArrivalMaterialService.createByReserves(rowSelection, currentEditRowData, currentCurrencyId, currentWarehouseId,
            ).then(function () {
                setChange(!change)
                setOpenSelectRowModal(false)
                setRowSelection([])
                setFillReserveMaterial(null)
                handleCloseCreateOrUpdateModalOpen();
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const handleSubmitCreateForIndividualReserves = () => {
            currentEditRowData.date = date === null ? null : DateTimeUtil.dateConvert(date);
            currentEditRowData.materialDeliveryDate = materialDeliveryDate === null ? null : DateTimeUtil.dateConvert(materialDeliveryDate);

            const currentCurrencyId = currencyId === null ? currencyList[0].id : currencyId;
            const currentWarehouseId = warehouseId == null ? warehouseList[0].id : warehouseId;

            ArrivalMaterialService.createForIndividualReserves(rowSelection, currentEditRowData, currentCurrencyId, currentWarehouseId,
            ).then(function () {
                setChange(!change)
                setOpenSelectRowModal(false)
                setRowSelection([])
                setFillReserveMaterial(null)
                handleCloseCreateOrUpdateIndividualModalOpen();
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const navigate = useNavigate();

        const redirectMaterialsArrival = () => {
            navigate('/organization/materials-arrival');
        };

        const handleSelectAction = (type, supplier, handleCancel) => {
            if (type === "createByReserves") {
                handleCreateData()
            } else if (type === "createForIndividualReserves") {
                handleCreateIndividualData()
            } else if (type === "fillReserve") {
                handleFillReserve()
            } else if (type === "editSupplier") {
                setLoading(true)
                MaterialReserveService.setSupplierByIds(rowSelection, supplier, typeMaterial)
                    .then(function (response) {
                        const newData = data.map(el => {
                            const supplierMaterial = response.data.find(item => item.id === el.id)?.supplierMaterial
                            return rowSelection.includes(el.id) ? {
                                ...el,
                                supplierName: supplierMaterial.supplier.name,
                                supplierMaterialId: supplierMaterial.id,
                                supplierId: supplierMaterial.supplier.id
                            } : el
                        })
                        setData(newData)
                        calcWarningString(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleCancel()
                        setRowSelection([])
                        setFillReserveMaterial(null)
                        handleModalAlert("Данные изменены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
            } else if (type === "delete") {
                MaterialReserveService.deleteByIds(rowSelection).then(function () {
                    setOpenSelectRowModal(false)
                    setRowSelection([])
                    setFillReserveMaterial(null)
                    const newData = data.filter(el => !rowSelection.includes(el.id))
                    setData(newData)
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Данные удалены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            } else if (type === "deleteArrival") {
                handleDeleteArrival()
            } else {
                setLoading(true)
                MaterialReserveService.returnPurchases(rowSelection).then(function () {
                    setOpenSelectRowModal(false)
                    setRowSelection([])
                    setFillReserveMaterial(null)
                    const newData = data.filter(el => !rowSelection.includes(el.id))
                    setData(newData)
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Данные изменены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
            }

        }
        const handleDivide = (row) => {
            setModalDivide(true)
            setCurrentEditRowData(row)
        }
        const handleSetReserveState = (row, state) => {
            setLoading(true)
            MaterialReserveService.setState(row.id, state)
                .then(function () {
                    const newData = data.map(el => el.id === row.id ? {...el, materialReserveState: state} : el)
                    setData(newData)
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Статус изменён", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }
        const divideReserve = (value) => {
            setLoading(true)
            MaterialReserveService.divide(currentEditRowData.id, value.name)
                .then(function (response) {
                    const newData = data.filter(el => el.id !== currentEditRowData.id).concat(response.data)
                    setData(newData);
                    handleModalAlert("Резервы разделены", 'success')
                    calcWarningString(newData)
                    handleSearchQuery(globalFilter, newData)
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }
        const handleClose = () => {
            setModalDivide(false)
            setCurrentEditRowData(null)
        }
        const modalActions = [
            {name: "Создать закупку", type: "createByReserves"},
            {name: "Создать закупку по отдельным резервам", type: "createForIndividualReserves"},
            {name: "Убрать из закупки", type: "returnPurchase"},
            {name: "Изменить поставщика", type: "editSupplier"},
            {type: "delete", name: "Удалить резервы"},
            {type: "fillReserve", name: "Заполнить резерв"},
            {type: "deleteArrival", name: "Убрать из прихода"},
        ]

        const menuItem = [
            {type: "edit", text: "Изменить поставщика", handler: handleUpdateReserve},
            {type: "returnPurchase", text: "Убрать из закупки", handler: handleReturnPurchase},
            {type: "delete", text: "Удалить резерв", handler: handleDelete},
            {type: "fillReserve", text: "Заполнить резерв", handler: handleFillReserve},
            {type: "deleteArrival", text: "Убрать из прихода", handler: handleDeleteArrival},
            {type: "divide", text: "Разделить резерв", handler: handleDivide},
            ...(isSettingsRole ? [{type: "setState", text: "Установить статус"}] : []),
        ]
        const activeColumn = typeMaterial === 'SLAB' ? "&:nth-of-type(3)" : "&:nth-of-type(2)"
        return (
            <Box sx={{maxWidth: (isColumnOptimization && isColumnMaterialWarehouse) ? "2780px" : "2600px"}}>
                <Box
                    sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
                >
                    <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "9px"}}>
                        {warningIds.length > 0 && <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            sx={{
                                animation: 'blinking 1s infinite',
                                WebkitAnimation: 'blinking 1s infinite',
                                '@keyframes blinking': {
                                    '0%': {backgroundColor: '#fff'},
                                    '50%': {backgroundColor: "rgb(244, 191, 114);"},
                                    '100%': {backgroundColor: '#fff'},
                                },
                            }}
                        >
                            Присутствуют дубликаты
                        </Button>}
                        <ButtonCreate
                            text={"Приход материалов"}
                            width={170}
                            icon={false}
                            onClick={redirectMaterialsArrival}
                        />
                    </Box>
                </Box>
                <MaterialReactTable
                    muiTableContainerProps={{
                        sx: {
                            maxHeight: rowSelection?.length > 0 ? `calc(100vh - 530px)` : `calc(100vh - 450px)`,
                        }
                    }}
                    muiTableBodyCellProps={({cell}) => {
                        return ({
                            sx: {
                                p: ['mrt-row-select', "mrt-row-expand", "materialName"].includes(cell.column.id) ? "0 10px" : '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                "&:after": {
                                    display: "none",
                                },
                                "& td:after": {
                                    "&:hover": {
                                        backgroundColor: "red"
                                    }
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                [activeColumn]: {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }

                                }
                            },
                        })
                    }}
                    muiTableHeadCellProps={({table, column}) => {
                        return ({
                            sx: {
                                border: '1px solid #EAEBEA',
                                backgroundColor: "#F5F6FA",
                                padding: ['mrt-row-select', "mrt-row-expand"].includes(column.id) ? "0 5px" : ["quantity", "availabilityQuantity", "orderedQuantity", "needToOrderQuantity", "quantityInStock"].includes(column.id) ? 0 : '0px 0px 0px 10px',
                                verticalAlign: "bottom",
                                "& .Mui-TableHeadCell-Content": {
                                    alignItems: "end",
                                    "& .Mui-TableHeadCell-Content-Wrapper": {
                                        justifyContent: "center",
                                        display: "flex",
                                    },
                                    "& .Mui-TableHeadCell-Content-Labels": {
                                        alignItems: "end",
                                        "& span": {
                                            marginBottom: "3px"
                                        }
                                    }
                                },
                                "& .MuiCollapse-root .MuiSelect-select": {
                                    padding: "0 !important",
                                    "& .MuiChip-label": {
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }
                                }
                            },
                        })
                    }}
                    muiTableBodyRowProps={({row}) => {
                        const warningString = warningIds?.includes(row.original.id) || row.leafRows?.some(el => warningIds?.includes(el.id))

                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: warningString ? "rgb(255, 203, 127);" : "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                            muiTableBodyCellProps: {
                                align: 'center',
                            },
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                        "mrt-row-expand": {
                            size: "50px",
                            grow: false,

                        }
                    }}
                    columns={columns}
                    data={filteredData}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        expanded: expanded,
                        grouping: columnGrouping,
                        columnPinning: {
                            left: ['materialName'],
                        },
                    }}
                    enableGrouping={enableGrouping}
                    onRowSelectionChange={onRowSelectionChange}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    onGlobalFilterChange={(value) => {
                        handleSearchQuery(value, data, null)
                    }}
                    onColumnFiltersChange={(updater) => {
                        handleSearchQuery(updater(columnsFilter), data, null, true)
                    }}
                    onShowColumnFiltersChange={handleShowColumnFilters}
                    state={{
                        showColumnFilters: showColumnFilters,
                        columnFilters: columnsFilter,
                        globalFilter: globalFilter,
                        rowSelection: currentSelection,
                        showGlobalFilter: true,
                        pagination: tableOptions,
                    }}
                    manualFiltering={true}
                    paginateExpandedRows={false}
                    enableRowSelection={true}
                    enableRowActions={true}
                    getRowId={(originalRow) => originalRow.id}
                    enableToolbarInternalActions={false}
                    selectionPadding={1}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    selectAllMode={'all'}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                            },
                        }
                    }}
                    renderTopToolbar={({table}) => {
                        const backgroundBlue = table.getState().grouping.length > 0 || table.getSelectedRowModel().rows.length > 0
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => backgroundBlue ? theme.palette.primary.light : "transparent",
                            "& .MuiStack-root": {
                                padding: "1px",
                                flexDirection: "row-reverse",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "40px",
                            },
                        }}>
                            <MRT_ToolbarAlertBanner
                                table={{...table, options: {...table.options, rowCount: tableOptions.totalElements}}}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    renderBottomToolbar={({table}) => {
                        const tableProps = table.getState().grouping.length > 0
                            ? {
                                ...table,
                                options: {
                                    ...table.options,
                                    localization: {
                                        ...table.options.localization,
                                        rowsPerPage: `Всего строк: ${tableOptions.totalElements}. Сгруппированных элементов на странице:`
                                    }
                                }
                            }
                            : table
                        return <MRT_BottomToolbar table={tableProps}/>
                    }}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        if (el.type === "setState") {
                            return (
                                <SetStatusMenuItem
                                    key={el.type}
                                    row={row}
                                    closeMenu={closeMenu}
                                    onSetState={handleSetReserveState}
                                />
                            );
                        }
                        return <MenuItem
                            key={el.type}
                            disabled={el.type === "returnPurchase" && row.original.materialReserveState !== 'WAITING_FOR_AN_APPLICATION'}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={rowActionMenuItemSx}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    localization={MRT_Localization_RU}
                />
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={handleOpenSelectRowModal}/>
                </Paper>}
                <ModalUpdateOrAddMaterialArrival
                    open={createOrUpdateModalOpen}
                    handleClose={() => handleCloseCreateOrUpdateModalOpen()}
                    title={titleModalUpdateOrAddMaterialArrival}
                    values={currentEditRowData}
                    setValues={setCurrentEditRowData}
                    date={date}
                    setDate={setDate}
                    materialDeliveryDate={materialDeliveryDate}
                    setMaterialDeliveryDate={setMaterialDeliveryDate}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    setCurrencyId={setCurrencyId}
                    supplierList={supplierList}
                    supplierId={supplierId}
                    setSupplierId={setSupplierId}
                    warehouseList={warehouseList}
                    warehouseId={warehouseId}
                    setWarehouseId={setWarehouseId}
                    handleSubmit={handleSubmitCreateByReserves}
                    isNew={true}
                    reserve={true}
                    loading={loading}
                />
                <ModalUpdateOrAddMaterialArrival
                    open={createOrUpdateIndividualModalOpen}
                    handleClose={() => handleCloseCreateOrUpdateIndividualModalOpen()}
                    title={titleModalUpdateOrAddMaterialArrival}
                    values={currentEditRowData}
                    setValues={setCurrentEditRowData}
                    date={date}
                    setDate={setDate}
                    materialDeliveryDate={materialDeliveryDate}
                    setMaterialDeliveryDate={setMaterialDeliveryDate}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    setCurrencyId={setCurrencyId}
                    supplierList={supplierList}
                    supplierId={supplierId}
                    setSupplierId={setSupplierId}
                    warehouseList={warehouseList}
                    warehouseId={warehouseId}
                    setWarehouseId={setWarehouseId}
                    handleSubmit={handleSubmitCreateForIndividualReserves}
                    isNew={true}
                    reserve={true}
                    loading={loading}
                />
                <ModalSetSupplier
                    open={setSupplierModalOpen}
                    handleClose={() => handleCloseUpdateReserve()}
                    title={"Изменить поставщика"}
                    currentEditRowData={currentEditRowData}
                    handleSubmit={handleSetSupplier}
                    handleModalAlert={handleModalAlert}
                    currencyMap={currencyMap}
                    typeMaterial={typeMaterial}
                    loading={loading}
                />
                <ModalSelectAction
                    open={openSelectRowModal}
                    reset={() => setOpenSelectRowModal(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                    supplierList={supplierList}
                    fillReserveDisabled={!fillReserveMaterial}
                    loading={loading}
                />
                {fillReserveModalOpen && <ModalWarehouse
                    open={fillReserveModalOpen}
                    handleModalAlert={handleModalAlert}
                    currentSlab={typeMaterial === "SLAB"}
                    handleClose={handleCloseWarehouse}
                    currentEditRowData={currentEditRowData}
                    fillReserveMaterial={fillReserveMaterial}
                    handleSubmit={handleSubmitWarehouse}
                    loading={loading}
                />}
                <NameModal
                    title={"Введите количество"}
                    type={"number"}
                    label={"Количество"}
                    open={modalDivide} onClose={handleClose}
                    handleSubmit={divideReserve}
                    initValue={{name: ""}}
                    loading={loading}/>
            </Box>
        );
    }
;
const ModalWarehouse = ({
                            open,
                            handleClose,
                            handleSubmit,
                            currentEditRowData,
                            fillReserveMaterial,
                            handleModalAlert,
                            currentSlab,
                            loading
                        }) => {
    const [dataMaterialWarehouse, setDataMaterialWarehouse] = useState([]);
    const [selectedString, setSelectedString] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 20,
        totalElements: 0,
        searchData: ""
    })
    useEffect(() => {
            MaterialWarehouseService.getAllByMaterialId(currentEditRowData?.materialId || fillReserveMaterial)
                .then(function (response) {
                    const data = response.data;
                    setDataMaterialWarehouse(data);
                })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, [open]
    );
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    const onClose = () => {
        setDataMaterialWarehouse([])
        setSelectedString({})
        handleClose()
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: {
                    minWidth: `2000px`,
                }
            }}>
                <DialogTitle textAlign="center">Выбрать склад</DialogTitle>
                <Box sx={{
                    height: "32px",
                    fontSize: "18px",
                    margin: "0px 40px 0px 40px",
                    display: "flex",
                    alignItems: "center",
                    '& .MuiTypography-root': {
                        fontWeight: (theme) => theme.typography.fontWeight,
                        color: (theme) => theme.palette.text.main,
                        '&:first-of-type': {
                            marginRight: '10px'
                        }
                    },
                }}>
                    <Typography component="p">{currentEditRowData?.materialArticleNumber}</Typography>
                    <Typography component="p">{currentEditRowData?.materialName}</Typography>
                </Box>
                <DialogContent>
                    <MaterialWarehouseTableRMEU
                        data={dataMaterialWarehouse}
                        selectedMaterial={selectedString}
                        selectMaterial={setSelectedString}
                        currentSlab={currentSlab}
                    />
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd
                        loading={loading}
                        text={"Выбрать"} disabled={!selectedString?.id}
                        onClick={() => handleSubmit(selectedString?.id, onClose)}
                    />
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default ReservationMaterialTable;